import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ScreenService extends RestfulService<Models.Screen> {

  constructor(private restService: RestService) {
    super(Models.Screen);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('screens');
  }

}
